import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Transaction from '../../entities/transaction';
import Invoice from '../../entities/invoice';

/*
 * Delete/nullify anywhere this transaction is used in other entities
 *
 * @param {Transaction} transaction
 */
export function deleteTransaction(transaction: Transaction, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = transaction.id;
    }
    /* Simple delete usages */
        
    store.getState().invoices
        .getMappingFor('transactionId', transaction.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.transactionIds = _invoice.transactionIds?.filter(id => id !== transaction.id) || [];
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    /* Remove the actual transaction */
    transaction.status = 'D';
    transaction.addedOn = newHRTimestamp();
    transaction.addedBy = getCurrentUserId();
    transaction.importSource = targetImportSource;
    transaction.importId = mergeId;
    store.dispatch(Actions.TransactionActions.removeTransactionQueue(transaction));
    
}

/*
 * Replace anywhere this transaction is used in other entities.
 *
 * @param {Transaction} transaction
 * @param {Transaction} replaceWith
 * @return {Transaction} - Transaction will have refs stripped away
 */
export function replaceTransaction(transaction: Transaction, replaceWith: Transaction, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = transaction.id;
    }
    /* Simple replace usages */
        
    store.getState().invoices
        .getMappingFor('transactionId', transaction.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.transactionIds = _invoice.transactionIds?.map(id => (id === transaction.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    return transaction;
}

/*
 * Determine the impact of deleting this transaction from other entities
 *
 * @param {Transaction} transaction
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactTransaction(transaction: Transaction) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const invoiceTransactionIdsImpact = state.invoices
          .getMappingFor('transactionId', transaction.id)
          .filter(invoice => invoice.status !== 'D');

    invoiceTransactionIdsImpact.forEach(() => impacts.push('invoices'));

    return util.countDistinct(impacts);
}